<template>
  <div class="edit-caption-form">
    <!-- Header -->
    <div class="header edit-caption-form__header">
      <div class="header__back-link-wrap">
        <LinkWithIcon class="header__back-link" @click="emit('cancel')" isDottedUnderline>
          <template #icon><IconEmbedded name="arrow-left_2-5" :size="16" /></template>
          <span>Back to post usage</span>
        </LinkWithIcon>
      </div>

      <h1 class="global-h1 header__title">Edit Caption</h1>

      <textarea class="global-textarea edit-caption-form__textarea" :disabled="isSaving" v-model="_captionText"></textarea>
    </div>
    <!-- / Header -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

// Components
import LinkWithIcon from "@components/LinkWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

const props = withDefaults(
  defineProps<{
    captionText: string;
    saveCallBack: Function;
  }>(),
  {
    captionText: "",
    saveCallBack: () => {},
  }
);

const emit = defineEmits<{
  (e: "save", newCaptionText: string): void;
  (e: "cancel"): void;
}>();

// Local caption copy =========================================================
const _captionText = ref<string>("");

onMounted(() => (_captionText.value = props.captionText));

// Save =======================================================================
const isSaving = ref<boolean>(false);

async function save() {
  if (props.saveCallBack) {
    isSaving.value = true;
    await props.saveCallBack(_captionText.value);
    isSaving.value = false;
  }
  emit("save", _captionText.value);
}

// Define expose ==============================================================
defineExpose({
  save,
  cancel: () => emit("cancel"),
});
</script>

<style scoped lang="scss">
// Header =====================================================================
.header {
  &__back-link-wrap {
    padding-bottom: 15px;
    margin-bottom: 20px;
    border-bottom: 1px rgba(0, 0, 0, 0.15) solid;
  }

  &__back-link {
  }

  &__title {
    margin-bottom: 10px;
  }

  &__subtitle {
  }
}

// Edit caption form ==========================================================
.edit-caption-form {
  &__header {
  }

  &__textarea {
    min-height: 180px;
  }
}
</style>
